/**
 * Centralized Query Key Factory for Content Domain
 * Strictly scoped by organizationId to prevent cross-tenant cache bleeding.
 */
export const contentKeys = {
  all: ['content'] as const,
  posts: (orgId: string, campaignInfluencerId?: string | null) =>
    ['influencer-posts', orgId, campaignInfluencerId] as const,
  legacyPosts: (campaignInfluencerId?: string | null) =>
    ['influencer-posts', campaignInfluencerId] as const,
  metricsHistory: (orgId: string, submissionId?: string | null) =>
    ['metrics-history', orgId, submissionId] as const,
  legacyMetricsHistory: (submissionId?: string | null) =>
    ['metrics-history', submissionId] as const,
  topPosts: (orgId?: string, campaignId?: string | null) =>
    campaignId
      ? (['top-performing-posts', campaignId, orgId] as const)
      : (['top-performing-posts'] as const),
  folders: (orgId: string, campaignId?: string | null) =>
    ['content-folders', orgId, campaignId] as const,
  legacyFolders: (campaignId?: string | null) =>
    ['content-folders', campaignId] as const,
  images: (orgId: string, campaignId?: string | null) =>
    ['content-images', orgId, campaignId] as const,
  legacyImages: (campaignId?: string | null) =>
    ['content-images', campaignId] as const,
};
